module.exports = __webpack_public_path__ + "static/sq_man_-d3087a9a7f0168a53acbadab5b6c61ef.png";